import StatusLight from './StatusLight';

export default StatusLight;
